import { transport } from 'config/transport';

export function callApiExportCongDoanVungAnnuallyReport(congDoanId, academicYear, pdf = false, submitToTW = false) {
    return transport.get(`/congdoanvung/${congDoanId}/thuchi/exportReportAnnually`, { params: { academicYear, pdf, submitToTW }, responseType: 'blob' });
}
